// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__PsJMa","description":"MealItem_description__1Z7qm","price":"MealItem_price__1hmK6"};